<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="模版名称" prop="name" required>
        <el-input v-model="form.name" placeholder="请输入模版名称" v-trim/>
      </el-form-item>
      <el-form-item label="模版编码" prop="name" required>
        <el-input v-model="form.code" placeholder="请输入模版编码" v-trim/>
      </el-form-item>
      <el-form-item label="关键字" prop="keywords" required>
        <ListInput v-model="form.keywords" placeholder="请输入关键字"/>
      </el-form-item>
      <el-form-item label="部署脚本" prop="deployCommand">
        <el-input type="textarea" v-model="form.deployCommand" :rows="8" placeholder="请输入部署脚本" v-trim/>
      </el-form-item>
      <el-form-item label="Nginx配置" prop="nginxConfig">
        <el-input type="textarea" v-model="form.nginxConfig" :rows="8" placeholder="请输入Nginx配置" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="form.remark" :rows="8" placeholder="请输入备注" maxlength="500" show-word-limit v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import ListInput from '@/components/common/ListInput'
export default {
  name: 'OperaTemplateWindow',
  extends: BaseOpera,
  components: { ListInput, GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        code: '',
        name: '',
        keywords: '',
        deployCommand: '',
        nginxConfig: '',
        remark: '',
        disabled: false
      },
      // 验证规则
      rules: {
        code: [
          { required: true, message: '请输入模版编码' }
        ],
        name: [
          { required: true, message: '请输入模版名称' }
        ],
        keywords: [
          { required: true, message: '请输入关键字' }
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/template/list',
      'field.id': 'id'
    })
  }
}
</script>
